import React from 'react';
import PropTypes from 'prop-types';
import EventCard from './EventCard';

const ScheduleTableCell = (props) => {
    let medalsCounter = 0;
    if (props.dayEvents && props.dayEvents.length) {
        props.dayEvents.forEach((eventId) => {
            if (props.allEvents[eventId].isSummary) {
                medalsCounter += 1;
            }
        });
    }

    function hoverEntre(e) { 
        const cellArr = document.querySelectorAll(`.schedule-table__cell[data-day='${e.target.dataset.day}']`);
        const dayArr = document.querySelectorAll(`.schedule-title__day[data-day='${e.target.dataset.day}']`);
        cellArr.forEach(item => item.classList.add('table_active'));
        dayArr.forEach(item => item.classList.add('table_active'));
    } 
    function hoverOut(e) { 
        const cellArr = document.querySelectorAll(`.schedule-table__cell[data-day='${e.target.dataset.day}']`);
        const dayArr = document.querySelectorAll(`.schedule-title__day[data-day='${e.target.dataset.day}']`);
        cellArr.forEach(item => item.classList.remove('table_active'));
        dayArr.forEach(item => item.classList.remove('table_active'));
    } 

    const clickHandler = () => {
        props.toggleEventCard(props.sportName, props.date);
    };

    const cellContent = () => (
        medalsCounter ?
            (<div className="schedule-table__counter" onMouseLeave={hoverOut} onMouseOver={hoverEntre} onClick={clickHandler} role="button" tabIndex={0}>
                { medalsCounter }
            </div>)
            :
            (<div className="schedule-table__bullet" onMouseLeave={hoverOut} onMouseOver={hoverEntre} onClick={clickHandler} role="button" tabIndex={0} />)
    );  

    return (
        <div className="schedule-table__cell" data-day={+props.date} onMouseLeave={hoverOut} onMouseOver={hoverEntre}>
            { props.dayEvents ? cellContent() : null }

            { props.dayEvents && props.showCard ? (<div className="schedule-table__card">
                <EventCard
                    dayEvents={props.dayEvents}
                    name={props.sportName}
                    allEvents={props.allEvents}
                />
            </div>) : null }
        </div>
    );
};

ScheduleTableCell.propTypes = {
    // eslint-disable-next-line
    dayEvents: PropTypes.any,
    // eslint-disable-next-line
    allEvents: PropTypes.any,
    sportName: PropTypes.string,
    date: PropTypes.string.isRequired,
    toggleEventCard: PropTypes.func,
    showCard: PropTypes.bool
};


ScheduleTableCell.defaultProps = {
    sportName: '',
    toggleEventCard: null,
    showCard: false
};

export default ScheduleTableCell;



// WEBPACK FOOTER //
// ./src/components/ScheduleTableCell.jsx